import Header from "@/components/header";
import CustomStepper from "@/components/stepper";
import useCreateAppointment from "@/services/appointment/hooks/useCreateAppointment";
import useScheduleStore from "@/store/schedule";
import {
  Badge,
  Button,
  Card,
  Divider,
  Group,
  Stack,
  Text,
  Textarea,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import moment from "moment-jalaali";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { selectedTimeCapacity, stepperAppointment } from "../type";

function SaveAppointment() {
  const { mutate, isLoading } = useCreateAppointment();
  const navigate = useNavigate();
  const [description, setDescription] = useState("");
  const [selectedTimes, setSelectedTimes] = useState<selectedTimeCapacity[]>();
  const {
    selectCustomer,
    selectService,
    selectedAppointmentDate,
    selectedAppointmentTime,
  } = useScheduleStore();
  const submit = () => {
    mutate(
      {
        customerId: selectCustomer?.id,
        description: description,

        // appointments: [],
        // selectedTimes?.map((item) => ({
        //   count: item?.capacity,
        //   date:
        //     moment(selectedAppointmentDate)
        //       .locale("fa")
        //       .format("YYYY-MM-DD") +
        //     "T" +
        //     item?.title +
        //     ":00Z",
        // })) || [],
      },
      {
        onSuccess() {
          notifications.show({
            title: "عملیات موفق",
            message: "عملیات با موفقیت صورت پذیرفت",
            color: "green",
          });
          navigate("/dashboard/schedule", {
            replace: true,
          });
        },
      }
    );
  };

  useEffect(() => {
    const items: selectedTimeCapacity[] =
      selectedAppointmentTime?.map((item, index) => ({
        id: index + 1,
        title: item,
        capacity: 1,
      })) || [];

    setSelectedTimes(items);
  }, [selectedAppointmentTime]);

  return (
    <Stack
      style={{
        display: "flex",
        height: "100svh",
      }}
    >
      <Header showBack showHome title="افزودن نوبت" />
      <CustomStepper steppers={stepperAppointment} active={3} />
      <Stack px="md" flex={1} justify="space-between" my="md">
        <Stack>
          <Card withBorder>
            <Stack justify="space-between" gap="xs">
              <Group justify="space-between">
                <Text size="sm" fw="800">
                  مشتری
                </Text>
                <Stack gap="xs" justify="start" align="end">
                  <Text size="xs">
                    {selectCustomer?.firstName} {selectCustomer?.lastName}
                  </Text>
                  <Text size="xs">{selectCustomer?.phoneNumber}</Text>
                </Stack>
              </Group>
            </Stack>
            <Divider my="md" />
            <Stack justify="space-between" gap="xs">
              <Group justify="space-between">
                <Text size="sm" fw="800">
                  سرویس :
                </Text>
                <Group>
                  <Badge variant="light">
                    <Text size="xs">{selectService?.title} </Text>
                  </Badge>
                </Group>
              </Group>
            </Stack>
            <Divider my="md" />

            <Group justify="space-between">
              <Text size="sm" fw="800">
                تاریخ انتخابی :
              </Text>
              <Stack align="end">
                <Text size="xs">
                  {moment(selectedAppointmentDate)?.format(
                    "dddd jD jMMMM jYYYY"
                  )}
                </Text>
              </Stack>
            </Group>
            <Divider my="md" />
            <Stack>
              <Group justify="space-between">
                <Text size="sm" fw="800">
                  ساعت
                </Text>
                <Text size="sm" fw="800">
                  تعداد نوبت
                </Text>
              </Group>
              {selectedTimes
                ?.sort((a, b) => a.title.localeCompare(b.title))
                ?.map((x) => (
                  <Group justify="space-between">
                    <Badge variant="light">
                      <Text size="xs">{x?.title}</Text>
                    </Badge>
                    {/* <NativeSelect
                      value={x?.capacity}
                      onChange={(e) =>
                        setSelectedTimes(
                          selectedTimes?.map((item) => {
                            if (item.title === x.title) {
                              return {
                                ...item,
                                capacity: Number(e.target.value),
                              };
                            }
                            return item;
                          })
                        )
                      }
                      data={
                        Array.from(
                          { length: selectService?.capacity || 1 },
                          (_, i) => ({
                            label: (i + 1).toString(),
                            value: (i + 1).toString(),
                          })
                        ) || []
                      }
                    /> */}
                  </Group>
                ))}
            </Stack>
          </Card>
          <Textarea
            label="توضیحات"
            size="md"
            onChange={(e) => setDescription(e.target.value)}
          />
        </Stack>
        {/* <Button
         form="type-selector"
         type="submit"
         size="md"
         onClick={calculateAmount}
         loading={isCheckAmountLoading || isCheckAmountCustomerIdLoading}
        >
            محاسبه قیمت و ثبت
        </Button> */}
      </Stack>
      <Stack px="md" mb="md">
        <Button
          type="submit"
          form="editTemplate"
          size="md"
          onClick={submit}
          loading={isLoading}
        >
          <Text>تایید نهایی </Text>
        </Button>
      </Stack>
    </Stack>
  );
}

export default SaveAppointment;
